var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53878 9.31584C3.71008 9.7251 4.28992 9.7251 4.46123 9.31584L7.7394 1.48416C7.8773 1.15472 7.63531 0.791103 7.27817 0.791103H0.721828C0.364689 0.791103 0.122705 1.15472 0.260602 1.48416L3.53878 9.31584Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownPagination);
export default __webpack_public_path__ + "static/media/dropdown-pagination.267c249fb4244eaf23f037e3bfad7ab6.svg";
export { ForwardRef as ReactComponent };